import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/** 일렉트론이 넘겨준 예약시트 초기 데이터 */
export type ReservationSheetState = {
    data: unknown[]
}

const state: ReservationSheetState = {
    data: [],
}

type Store = { commit(type: string, payload: unknown): void }

const actions = {
    'setReservationSheet': (store: Store, array: unknown[]): void => {
        store.commit('muReservationSheet', array)
    },
}

const mutations = {
    'muReservationSheet': (state: ReservationSheetState, array: unknown[]): void => {
        state.data = array
    },
}

const rm_reservationsheet: Module<ReservationSheetState, StoreState> = { state, actions, mutations }

export default rm_reservationsheet
